import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { MultiActionPage } from "./multi-action.page";
import { TranslateModule } from "@ngx-translate/core";
import { GetActionsModule } from "./pipes/get-actions/get-actions.module";
import { ToActionModule } from "src/app/pipes/to-action/to-action.module";
import { ActionSelectorPageModule } from "../action-selector/action-selector.module";
import { ToChanceNodeModule } from "src/app/pipes/to-chance-node/to-chance-node.module";
import { ActionDescriptionModule } from "./pipes/action-description/action-description.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    GetActionsModule,
    ToActionModule,
    ToChanceNodeModule,
    ActionSelectorPageModule,
    ActionDescriptionModule,
  ],
  declarations: [MultiActionPage],
})
export class MultiActionPageModule {}
